<table class="documents-table">
    <thead>
        <tr>
            <th><span (click)="orderBy('documentNumber')" translate>COMPLAINT|Nr zgłoszenia <icc-sort-order-icon [sort]="columnSortOptions['documentNumber']"></icc-sort-order-icon></span></th>
            <th *ngIf="viewComplaintOrderNumber"><span style="cursor: default" translate>COMPLAINT|Nr zamówienia pierwotnego</span></th>
            <th><span (click)="orderBy('client')" translate>COMPLAINT|Klient <icc-sort-order-icon [sort]="columnSortOptions['client']"></icc-sort-order-icon></span></th>
            <th><span (click)="orderBy('priority')" translate>COMPLAINT|Priorytet <icc-sort-order-icon [sort]="columnSortOptions['priority']"></icc-sort-order-icon></span></th>
            <th>
                <span (click)="orderBy('created')" translate>INTERFACE|Data utworzenia <icc-sort-order-icon [sort]="columnSortOptions['created']"></icc-sort-order-icon></span>
                <span (click)="orderBy('modified')" translate>INTERFACE|Data modyfikacji <icc-sort-order-icon [sort]="columnSortOptions['modified']"></icc-sort-order-icon></span>
            </th>
            <th>
                <span (click)="orderBy('assignedToCompany')">{{ 'COMPLAINT|Przypisanie' | translate }}<icc-sort-order-icon [sort]="columnSortOptions['assignedToCompany']"></icc-sort-order-icon></span>
            </th>
            <th>
                <span (click)="orderBy('status')" translate>COMPLAINT|Status <icc-sort-order-icon [sort]="columnSortOptions['status']"></icc-sort-order-icon></span>
            </th>
            <th translate>INTERFACE|Opcje</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let document of orderedDocuments  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
            <ng-container *ngTemplateOutlet="documentRow; context: {document: document, node: document }"></ng-container>
        </ng-container>
    </tbody>
</table>
<pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
></pagination-controls>

<ng-template #documentRow let-document="document" let-node="node">
    <tr [class.documents-table__row--error]="node.multipleWorkflows">
        <td class="documents-table__name" (click)="open(document)" >
            <span *ngIf="document?.documentNumber">
                {{ document?.documentNumber?.join ? document?.documentNumber.join('') : '' }}
            </span>

            <span *ngIf="mode === 'index' && documentActionsAccess.get(document.uuid)?.transferChanges" class="integrity-warning" (click)="showIntegrityWarning(document); $event.stopPropagation();">
                <br><icc-icon name="exclamation-triangle"></icc-icon> <span>{{ 'INTERFACE|Uwaga!' | translate }}</span>
            </span>
        </td>
        <td *ngIf="viewComplaintOrderNumber" class="documents-table__name" (click)="open(document)" >
            <ng-container *ngIf="getUniqueDistributorOrderNumbers(document).length > 0">
                <span *ngFor="let distributorOrderNumber of getUniqueDistributorOrderNumbers(document)">
                    {{ distributorOrderNumber }}
                </span>
            </ng-container>
        </td>
        <td class="documents-table__client" (click)="open(document)">
          <ng-container *ngIf="document?.clientName" >
            {{ document?.clientName }}
            <br>
          </ng-container>
          <ng-container *ngIf="!document?.clientName && document.authorizedRetailerCompanyId !== null" >
            {{ 'COMPLAINT|Zgłoszenie APSa' | translate }}
            <br>
          </ng-container>
          <ng-container *ngIf="!document?.clientName && document.authorizedRetailerCompanyId === null" >
            {{ 'COMPLAINT|Zgłoszenie dystrybutora' | translate }}
            <br>
          </ng-container>
          <small *ngIf="document?.installationAddress" >
            {{ document?.installationAddress }}
          </small>
        </td>
        <td class="documents-table__priority" (click)="open(document)">
            {{ getPriority(document) }}
        </td>
        <td class="documents-table__date" (click)="open(document)" >
            {{ document?.created | date : 'short' }}<br>
            {{ document?.modified | date : 'short' }}
        </td>
        <td class="documents-table__assign-to" (click)="open(document)">
            {{ getAssignedTo(document) }}<br>
        </td>
        <td class="documents-table__status" (click)="open(document)" *ngIf="showDocumentStatuses">
            <icc-complaint-status [status]="getStatus(document)"></icc-complaint-status>
        </td>
        <td>
            <div class="documents-table__options">
                <button iccButton appearance="secondary"  (click)="open(document)" *ngIf="mode === 'index' && !parent">
                  {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                </button>
            </div>
        </td>
    </tr>
</ng-template>
